import React, { useEffect, useRef } from 'react';

const CHARS = 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン0123456789ABCDEF';
const COLUMN_WIDTH = 18;

const MatrixRain = ({ intensity = 0.85 }) => {
  const canvasRef = useRef(null);
  const animRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener('resize', resize);

    const numColumns = Math.floor(canvas.width / COLUMN_WIDTH);
    const columns = [];
    const count = Math.floor(numColumns * intensity);

    for (let i = 0; i < count; i++) {
      const col = Math.floor(Math.random() * numColumns);
      columns.push({
        x: col * COLUMN_WIDTH,
        y: Math.random() * -canvas.height,
        speed: 1 + Math.random() * 3,
        chars: Array.from({ length: Math.floor(Math.random() * 12) + 8 }, () =>
          CHARS[Math.floor(Math.random() * CHARS.length)]
        ),
      });
    }

    const draw = () => {
      ctx.fillStyle = 'rgba(13, 2, 8, 0.15)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.font = `14px monospace`;

      columns.forEach(col => {
        col.chars.forEach((char, i) => {
          const y = col.y + i * 20;
          if (y < -20 || y > canvas.height + 20) return;

          if (i === 0) {
            ctx.fillStyle = '#FFFFFF';
            ctx.shadowColor = '#00FF41';
            ctx.shadowBlur = 8;
          } else if (i < 3) {
            ctx.fillStyle = '#00FF41';
            ctx.shadowBlur = 0;
          } else {
            ctx.fillStyle = `rgba(0, 170, 42, ${Math.max(0.15, 1 - i * 0.08)})`;
            ctx.shadowBlur = 0;
          }
          ctx.fillText(char, col.x, y);
        });

        col.y += col.speed;
        if (col.y > canvas.height + 50) {
          col.y = -col.chars.length * 20;
          col.x = Math.floor(Math.random() * numColumns) * COLUMN_WIDTH;
          col.chars = col.chars.map(() => CHARS[Math.floor(Math.random() * CHARS.length)]);
        }
      });

      animRef.current = requestAnimationFrame(draw);
    };

    animRef.current = requestAnimationFrame(draw);

    return () => {
      window.removeEventListener('resize', resize);
      if (animRef.current) cancelAnimationFrame(animRef.current);
    };
  }, [intensity]);

  return <canvas ref={canvasRef} className="matrix-rain" />;
};

export default MatrixRain;
